var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0026 14.6667H3.33594C2.23327 14.6667 1.33594 13.7693 1.33594 12.6667V4C1.33594 2.89733 2.23327 2 3.33594 2H7.33594V3.33333H3.33594C2.96794 3.33333 2.66927 3.63267 2.66927 4V12.6667C2.66927 13.034 2.96794 13.3333 3.33594 13.3333H12.0026C12.3706 13.3333 12.6693 13.034 12.6693 12.6667V8.66667H14.0026V12.6667C14.0026 13.7693 13.1053 14.6667 12.0026 14.6667Z",
    fill: "#680DDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4759 1.52945C13.6905 0.742786 12.3185 0.742786 11.5332 1.52945L5.40254 7.66012L4.42188 11.5841L8.34588 10.6028L14.4759 4.47212C15.2872 3.66079 15.2872 2.34079 14.4759 1.52945ZM13.5332 3.52945L12.3952 4.66745L11.3379 3.61012L12.4759 2.47212C12.7585 2.18945 13.2505 2.18945 13.5332 2.47212C13.8245 2.76345 13.8245 3.23812 13.5332 3.52945Z",
    fill: "#680DDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.fba2d6bddfe865586774b9ab64d19b96.svg";
export { ForwardRef as ReactComponent };